import { isEmpty } from 'ramda'

import Sticky from 'app/common/templates-next/sticky'
import { DotsLoader } from 'app/common/templates-next/page-template'
import PlainNav from 'app/common/ui-next/plain-nav'
import Link from 'app/common/lib/link'

import { useOrgsListNavigation, type NavItemProps } from './useOrgsListNavigation'
import styles from './OrgListNavigation.scss'

type Props = {
  onUpdateItems: (items: Array<NavItemProps>) => void
  orgType: string
}

const OrgsListNavigation = ({ onUpdateItems, orgType }: Props) => {
  const [items, loading] = useOrgsListNavigation({ onUpdateItems })

  if (loading === false && isEmpty(items)) {
    return null
  }

  return (
    <Sticky>
      {(ref) => (
        <div ref={ref} className={styles.root}>
          {loading && (
            <span>
              <DotsLoader simple />
              &nbsp;
            </span>
          )}
          <PlainNav NavComponent={Link} className={styles.nav} keepHeightOnEmpty>
            {items.map(({ key, to, children }) => (
              <PlainNav.Item key={key} to={to} active={key === orgType}>
                {children}
              </PlainNav.Item>
            ))}
          </PlainNav>
        </div>
      )}
    </Sticky>
  )
}

export default OrgsListNavigation
